import { CheckCircle2, ShieldCheck, FlaskConical } from "lucide-react";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_concrete-orders-48h/artifacts/or0w6zlh_48e66ce2-c2fa-4356-b582-e5c497f354b2.jpeg";

const POINTS = [
  "Beton certificat ISO, conform standardelor în vigoare.",
  "Rețete provenite din laborator autorizat — verificate.",
  "Două puncte de lucru: Fetești (sediu) + Slobozia.",
  "Flotă completă de autobetoniere și pompă de beton.",
];

export default function About() {
  return (
    <section id="despre" data-testid="about-section" className="py-20 sm:py-32 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-6 lg:gap-10 items-start">
          <div className="col-span-12 md:col-span-5 lg:col-span-6">
            <div className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#F59E0B] mb-6">
              · 01 / DESPRE NOI
            </div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.9] tracking-tight">
              Construim<br />
              pentru<br />
              <span className="text-[#F59E0B]">generații.</span>
            </h2>
          </div>

          <div className="col-span-12 md:col-span-7 lg:col-span-6">
            <p className="text-base sm:text-lg leading-relaxed text-neutral-700">
              <span className="font-bold text-black">Apolodor Com SRL</span>, cu sediul principal
              în Zona Industrială 804, Fetești și punct de lucru în Slobozia
              (Șos. Brăilei nr. 25E, Zona Industrială Nord-Est), vă oferă beton la cele mai înalte
              standarde, având o experiență de peste <span className="font-bold text-black">30 de ani</span> în domeniu.
              Domeniul nostru principal de activitate este executarea lucrărilor de
              construcții la clădiri rezidențiale și nerezidențiale.
            </p>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {POINTS.map((p, i) => (
                <li
                  key={i}
                  data-testid={`about-point-${i}`}
                  className="flex items-start gap-3 text-sm leading-relaxed text-neutral-800"
                >
                  <CheckCircle2 className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 sm:mt-20 relative">
          <div className="aspect-[21/9] w-full overflow-hidden border border-black/10">
            <img
              src={ABOUT_IMG}
              alt="Stația de betoane Apolodor Com SRL - silozuri ciment"
              className="w-full h-full object-cover"
              style={{ objectPosition: "center 60%" }}
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 left-6 sm:left-12 bg-[#F59E0B] text-black px-6 py-4 border border-black/10">
            <div className="font-display text-3xl sm:text-4xl leading-none">CAEN 4120</div>
            <div className="font-mono-tech text-[10px] sm:text-[11px] tracking-[0.2em] uppercase mt-1">
              Construcții Rezidențiale & Nerezidențiale
            </div>
          </div>
        </div>

        {/* Certifications band */}
        <div data-testid="certifications-band" className="mt-20 sm:mt-24 grid grid-cols-1 md:grid-cols-2 border border-black/15 bg-white">
          <div className="p-6 sm:p-8 flex items-start gap-5 border-b md:border-b-0 md:border-r border-black/15">
            <div className="w-12 h-12 sm:w-14 sm:h-14 flex-shrink-0 bg-[#0A0A0A] flex items-center justify-center">
              <ShieldCheck className="w-6 h-6 text-[#F59E0B]" strokeWidth={2} />
            </div>
            <div>
              <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[#F59E0B]">
                Calitate Certificată
              </div>
              <div className="font-display text-2xl sm:text-3xl uppercase tracking-tight leading-none mt-2">
                Beton Certificat ISO
              </div>
              <p className="text-sm text-neutral-600 mt-2 leading-relaxed">
                Producția respectă standardele ISO în vigoare — calitate constantă, verificată la fiecare șarjă.
              </p>
            </div>
          </div>

          <div className="p-6 sm:p-8 flex items-start gap-5">
            <div className="w-12 h-12 sm:w-14 sm:h-14 flex-shrink-0 bg-[#F59E0B] flex items-center justify-center">
              <FlaskConical className="w-6 h-6 text-black" strokeWidth={2} />
            </div>
            <div>
              <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-600">
                Rețetă Verificată
              </div>
              <div className="font-display text-2xl sm:text-3xl uppercase tracking-tight leading-none mt-2">
                Laborator Autorizat
              </div>
              <p className="text-sm text-neutral-600 mt-2 leading-relaxed">
                Betonul provine din laborator autorizat — compoziție și rezistență validate conform normativelor.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
